import React, { useState, useEffect } from "react";
import ScopeStackSpinner from "@components/ScopeStackSpinner/ScopeStackSpinner";
import Requests from "./Requests";

function PartnerRequests({
  partnerRequests,
  partners,
  isLoading,
  authorizationCode,
}) {
  useEffect(() => {}, [partnerRequests, partners, isLoading]);

  if (isLoading) {
    return (
      <div style={{ paddingTop: "20px" }}>
        <ScopeStackSpinner />
      </div>
    );
  } else {
    return (
      <Requests
        arr={partnerRequests}
        partners={partners}
        authorizationCode={authorizationCode}
      />
    );
  }
}

export default PartnerRequests;
